<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { __, __x } from 'JIX/gettext';
import DsSmallTip from 'JIX/components/ds/DsSmallTip.vue';
import DsCheckbox from '../ds/DsCheckbox.vue';

const props = defineProps({
    categorySuggestions: {
        type: Object,
        required: true,
    },
});

const store = useStore();
const categoriesToAdd = ref(props.categorySuggestions.suggestions.map(({ params }) => params));
const dismiss = ref(false);

function mergeCategoryLinks() {
    if (!categoriesToAdd.value.length) {
        return null;
    }
    const [firstCategory, ...otherCategories] = categoriesToAdd.value;
    otherCategories.forEach(category => {
        firstCategory.subid.push(category.subid[0]);
    });
    return firstCategory;
}

function handleSelectCategorySuggestion() {
    const params = mergeCategoryLinks();
    if (params) {
        store.commit('setSearchQuery', params);
        store.dispatch('performSearch');
    }
    dismiss.value = true;
}

</script>

<template>
    <DsSmallTip
        :heading-tag="__('Tip')"
        :heading="__('Anbefalet til din søgning')"
        dismissable
        v-if="!dismiss"
    >
        <div v-if="categorySuggestions.suggestions.length > 1">
            <div class="mb-1">
                {{ __('Vi anbefaler, at du tilføjer kategorier:') }}
            </div>
            <ul class="list-unstyled mb-3">
                <li v-for="category, index in categorySuggestions.suggestions" :key="category.name + index">
                    <DsCheckbox :name="category.name" :value="category.params" v-model="categoriesToAdd">
                        {{ category.name }}
                    </DsCheckbox>
                </li>
            </ul>
        </div>
        <div class="mb-3" v-else>
            {{ __x("Vi anbefaler, at du tilføjer kategorien '{category}' - så får du en bedre søgning.", { category: categorySuggestions.suggestions[0].name }) }}
        </div>
        <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="handleSelectCategorySuggestion"
        >
            {{ __('Tilføj kategori') }}
        </button>
    </DsSmallTip>
</template>
